export default __webpack_public_path__ + "static/media/noResultFound.77aff988.jpg";